import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';

import './CompanyFeatureManager.css';

import { toast } from 'react-toastify';
import LoadingSpinner from 'components/global/LoadingSpinner/LoadingSpinner';
import FormField from '../../contentform/FormField/FormField';

// Define 3 companies to put 
class CompanyFeatureManager extends React.Component {
  static propTypes = {
    companies: PropTypes.object,
    feature: PropTypes.array
  };

  state = {
    feature1: { company: '', featurePhoto: '' },
    feature2: { company: '', featurePhoto: '' },
    feature3: { company: '', featurePhoto: '' },
    feature4: { company: '', featurePhoto: '' },
    feature5: { company: '', featurePhoto: '' },
    feature6: { company: '', featurePhoto: '' },
    _dbLoaded: false
  };

  databaseToast = null;

  componentWillReceiveProps(nextProps) {
    if (!this.state._dbLoaded && isLoaded(nextProps.companies) && isLoaded(nextProps.feature)) {
      this.setState({
        feature1: { company: nextProps.feature[0] || '', featurePhoto: nextProps.feature[0] ? nextProps.companies[nextProps.feature[0]].featurePhoto : '' },
        feature2: { company: nextProps.feature[1] || '', featurePhoto: nextProps.feature[1] ? nextProps.companies[nextProps.feature[1]].featurePhoto : '' },
        feature3: { company: nextProps.feature[2] || '', featurePhoto: nextProps.feature[2] ? nextProps.companies[nextProps.feature[2]].featurePhoto : '' },
        feature4: { company: nextProps.feature[3] || '', featurePhoto: nextProps.feature[3] ? nextProps.companies[nextProps.feature[3]].featurePhoto : '' },
        feature5: { company: nextProps.feature[4] || '', featurePhoto: nextProps.feature[4] ? nextProps.companies[nextProps.feature[4]].featurePhoto : '' },
        feature6: { company: nextProps.feature[5] || '', featurePhoto: nextProps.feature[5] ? nextProps.companies[nextProps.feature[5]].featurePhoto : '' },
        _dbLoaded: true
      });
    }
  }

  handleFeatureCompanyChange = (feature, option) => {
    let newState = Object.assign(this.state);
    newState[feature].company = option.value;
    const currentPhoto = this.props.companies[option.value].featurePhoto;
    newState[feature].featurePhoto = currentPhoto || '';
    this.setState(newState);
  }

  handlefeaturePhotoChange = (feature, e) => {
    let newState = Object.assign(this.state);
    newState[feature].featurePhoto = e.target.value;
    this.setState(newState);
  }

  handleSave = () => {
    const companies = [
      this.state.feature1.company,
      this.state.feature2.company,
      this.state.feature3.company,
      this.state.feature4.company,
      this.state.feature5.company,
      this.state.feature6.company
    ];
    const features = [];
      companies.forEach((company) => {
        if (company) {
          features.push(company);
        }
      });
    const set = new Set(features);
    if (set.size === features.length) {
      this.databaseToast = toast.info('Saving...');
      const featureRef = '/companyFeature';
      const promises = [
        this.props.firebase.set(featureRef, features)
      ];
      if (this.state.feature1.company && this.state.feature1.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature1.company}/featurePhoto`, this.state.feature1.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature1.company}/featurePhoto`, this.state.feature1.featurePhoto)
        );
      }
      if (this.state.feature2.company && this.state.feature2.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature2.company}/featurePhoto`, this.state.feature2.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature2.company}/featurePhoto`, this.state.feature2.featurePhoto)
        );
      }
      if (this.state.feature3.company && this.state.feature3.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature3.company}/featurePhoto`, this.state.feature3.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature3.company}/featurePhoto`, this.state.feature3.featurePhoto)
        );
      }
      if (this.state.feature4.company && this.state.feature4.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature4.company}/featurePhoto`, this.state.feature4.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature4.company}/featurePhoto`, this.state.feature4.featurePhoto)
        );
      }
      if (this.state.feature5.company && this.state.feature5.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature5.company}/featurePhoto`, this.state.feature5.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature5.company}/featurePhoto`, this.state.feature5.featurePhoto)
        );
      }
      if (this.state.feature6.company && this.state.feature6.featurePhoto) {
        promises.push(
          this.props.firebase.set(`/company/${this.state.feature6.company}/featurePhoto`, this.state.feature6.featurePhoto),
          this.props.firebase.set(`/companyIndex/${this.state.feature6.company}/featurePhoto`, this.state.feature6.featurePhoto)
        );
      }
      Promise.all(promises)
        .then(() => {
          toast.update(
            this.databaseToast, {
              render: 'Save success!',
              type: toast.TYPE.SUCCESS,
              autoClose: 3000,
              className: 'JobForm-toast-transition'
            }
          );
        })
        .catch((error) => {
          toast.update(
            this.databaseToast, {
              render: `Error: ${error.message}`,
              type: toast.TYPE.ERROR,
              autoClose: 3000,
              className: 'JobForm-toast-transition'
            }
          );
        });
    } else {
      toast.error('Error: Duplicates detected. Please remove the duplicates and try again.');
    }
  }

  _renderCompanyOptions = () => {
    const { companies } = this.props;
    const filtered = [];
    Object.keys(companies)
      .forEach(companyCode => {
        // if (companies[companyCode].publishedDate) {
        //   filtered.push({ value: companyCode, label: companies[companyCode].name });
        // }
        filtered.push({ value: companyCode, label: companies[companyCode].name });
      });
    return filtered;
  }

  render() {
    const { companies, feature } = this.props;

    return (
      <div className='CompanyFeatureManager-root'>
        {
          !isLoaded(companies) || !isLoaded(feature) ? 
          <div className='CompanyTagManager-loadingContainer'>
            <LoadingSpinner />
          </div> :
          <div className='CompanyFeatureManager-form'>
            <h2 className='CompanyForm-sectionHeader'>Feature 1</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature1.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature1', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature1.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature1', e)}
            />
            <h2 className='CompanyForm-sectionHeader'>Feature 2</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature2.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature2', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature2.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature2', e)}
            />
            <h2 className='CompanyForm-sectionHeader'>Feature 3</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature3.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature3', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature3.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature3', e)}
            />
            <h2 className='CompanyForm-sectionHeader'>Feature 4</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature4.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature4', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature4.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature4', e)}
            />
            <h2 className='CompanyForm-sectionHeader'>Feature 5</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature5.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature5', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature5.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature5', e)}
            />
            <h2 className='CompanyForm-sectionHeader'>Feature 6</h2>
            <FormField
              type='select'
              name='company'
              title='Company*'
              subtitle='Company to feature (must be published)'
              value={this.state.feature6.company}
              options={this._renderCompanyOptions()}
              onChange={(option) => this.handleFeatureCompanyChange('feature6', option)}
            />
            <FormField
              type='text'
              name='featurePhoto'
              title='Feature Photo*'
              subtitle='A photo URL of the company for the feature'
              value={this.state.feature6.featurePhoto}
              onChange={(e) => this.handlefeaturePhotoChange('feature6', e)}
            />
            <div className='CompanyFeatureManager-buttonContainer'>
              <button
                className='CompanyForm-submitButton'
                type='button'
                onClick={this.handleSave}
              >
                SAVE
            </button>
            </div>
          </div>
        }
      </div>
    );
  }
}

const connectedCompanyFeatureManager = connect(
  (state) => ({
    companies: state.firebase.data.companyIndex,
    feature: state.firebase.data.companyFeature
  })
)(CompanyFeatureManager);

const wrappedCompanyFeatureManager = firebaseConnect([
  { path: '/companyIndex' },
  { path: '/companyFeature' }
])(connectedCompanyFeatureManager);

export default wrappedCompanyFeatureManager;



// WEBPACK FOOTER //
// ./src/components/companies/CompanyFeatureManager/CompanyFeatureManager.js